export default function searchOperator(items:any[], searchString:string, fieldsManager:any, columnsManager:any) {
    if (!searchString) return items;

    const searchableFields : any[] = [];
    _.map(columnsManager.all(), column => {
        if (!!column.type && column.type !== 'field') return; // if type is defined and is not 'field' then no search is available

        const Field = fieldsManager.get(column.fieldId);
        if (Field.isSearchable) searchableFields.push({id: column.fieldId, field: Field});
    })

    return _.filter(items, model => {

        let res = false;
        _.some(searchableFields, searchField=>{
            const value = searchField.field.searchValue(model[searchField.id], model);
            res = value && value.includes(searchString);
            return res;
        })

        return res;
    });
}